function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 3.135v.668a.485.485 0 01-.129.392.441.441 0 01-.642 0L1.234 3.078a.453.453 0 01-.084-.063l-.017-.012a.494.494 0 01-.108-.494.469.469 0 01.24-.28L2.73 1.14a.441.441 0 01.642 0 .485.485 0 01.13.39v.658h7.045c.25 0 .454.212.454.474a.464.464 0 01-.454.474H3.5z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
});

var SvgArrowLeftSmall = function SvgArrowLeftSmall(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='12' height='5' viewBox='0 0 12 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.50088 3.13489V3.80346C3.51674 3.9427 3.47349 4.08782 3.37113 4.19461C3.19376 4.37966 2.90612 4.37956 2.72863 4.19439L1.23395 3.07917C1.20427 3.062 1.17605 3.04111 1.14992 3.01647L1.13319 3.00399C1.04392 2.91087 0.999524 2.78867 1 2.66665C0.999796 2.6137 1.00804 2.5607 1.02474 2.51007C1.06473 2.38599 1.15263 2.28486 1.26553 2.23057L2.72863 1.13896C2.90612 0.953774 3.19376 0.953675 3.37113 1.13869C3.47349 1.24552 3.51674 1.39065 3.50088 1.52989V2.18724H10.5455C10.7965 2.18724 11 2.39938 11 2.6611C11 2.92278 10.7965 3.13489 10.5455 3.13489H3.50088Z' fill='currentColor' stroke='currentColor' stroke-width='0.5'/%3E %3C/svg%3E";
export { SvgArrowLeftSmall as ReactComponent };